import React from "react";
import DashboardHome from "./DashboardHome";

function AdminDashboard() {
  return (
    <div style={styles.container}>
      {/* Main Content */}
      <div style={styles.mainContent}>
        <div style={styles.navbar}>
          <h3>مرحبًا بك في لوحة التحكم 👋</h3>
        </div>
        <div style={styles.pageContent}>
          <DashboardHome />
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Cairo, sans-serif",
  },
  mainContent: {
    flex: 1,
    backgroundColor: "#f7f7fa",
    display: "flex",
    flexDirection: "column",
  },
  navbar: {
    backgroundColor: "#fff",
    padding: "15px 20px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  },
  pageContent: {
    flex: 1,
    padding: "20px",
    overflowY: "auto",
  },
};

export default AdminDashboard;
